<template>
    <div
        class="rounded-lg pt-2"
        :class="{ 'flex items-center justify-center': !chartOptions || !chartOptions.series }"
    >
        <no-data-animation v-if="loading" />
        <template v-else-if="chartOptions && chartOptions.series">
            <highcharts
                ref="area-chart"
                class="chart-content_wrapper"
                :options="chartOptions"
                :callback="onInitChartCallback"
                :updateArgs="[true, true]"
            />
        </template>
        <template v-else>
            <div>
                <WidgetNoData :widget="data" />
                <h3 class="text-main-xl text-center">{{ $t('general.noData') }}</h3>
            </div>
        </template>
    </div>
</template>
<script>
    import get from 'lodash/get'
    import Highcharts from 'highcharts'
    import { Chart } from 'highcharts-vue'
    import bus from '@/event-bus/EventBus'
    import Area from 'highcharts/modules/accessibility'
    import { getDefaultTimeDelay } from '@/enum/generic'
    import actionMixin from '@/components/Charts/Configs/actionMixin'
    import requestMixin from "@/mixins/requestMixin";
    import getDataIntervalMixin from '@/mixins/getDataIntervalMixin'

    Area(Highcharts);

    export default {
        mixins: [actionMixin, requestMixin, getDataIntervalMixin],
        components: {
            Highcharts,
            highcharts: Chart,
            NoDataAnimation: () => import('@/components/NoDataAnimation.vue'),
            WidgetNoData: () => import('@/components/Widgets/WidgetNoData')
        },
        props: {
            data: {
                type: Object,
                default: () => ({}),
            },
            editable: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                chartVisibility: true,
                chartOptions: {},
                chartInstance: false,
                loading: true
            }
        },
        computed: {
            outgoingAreaColor() {
                return get(this.data.WidgetLayout, 'colors.outgoing', '#61B5FE')
            },
            incomingAreaColor() {
                return get(this.data.WidgetLayout, 'colors.incoming', '#49CA6D')
            },
        },
        methods: {
            onInitChartCallback(chart) {
                this.chartInstance = chart
            },
            tryPrintChart() {
                const divToPrint = this.$el.children[0]
                const newWin = window.open();
                newWin.document.write(divToPrint.innerHTML);
                newWin.document.close();
                newWin.focus();
                newWin.print();
            },
            tryDownloadChart(type) {
                this.$refs['area-chart'].chart.exportChart({
                    type: type,
                })
            },
            async getWidgetData() {
                try {

                    let Data = await this.loadWidgetData(this.data)
                    this.chartOptions = get(Data, '0', {})

                    this.chartOptions['colors'] = [
                        this.incomingAreaColor,
                        this.outgoingAreaColor,
                    ]

                    this.reDrawChart()
                } catch (e) {
                    console.warn(e)
                    let status = get(e, 'response.status')
                    if (status === 400) {
                        let refreshDelay = getDefaultTimeDelay()
                        this.$set(this.data, 'DefaultRefreshInterval', refreshDelay)
                    }
                } finally {
                    this.loading = false
                }
            },
            onWidgetResizeHandler (widgetID) {
                if (this.data.WidgetID.toString() !== widgetID.toString()) {
                    return;
                }
                this.reDrawChart()
            },
            triggerResizeEvent() {
                bus.$on('widget-resized', this.onWidgetResizeHandler);
            },
            reDrawChart() {
                this.chartVisibility = false
                this.$nextTick(() => {
                    this.chartVisibility = true
                })
            },
        },
        mounted() {
            this.getWidgetData()

            this.triggerResizeEvent()
        },
        watch: {
            data: {
                immediate: true,
                handler: function () {
                    this.getDataWithRefreshInterval()
                },
            },
        },
        beforeDestroy() {
            bus.$off('widget-resized', this.onWidgetResizeHandler);
        }
    }
</script>
<style lang="scss" scoped>
.chart-content_wrapper {
    max-height: 400px;
}
</style>
<style>
.animation-block {
    height: 350px;
    width: 350px;
    margin: 0 auto;
    text-align: center;
}
</style>
